import { ParticipantKind, RoomEvent, Track } from 'livekit-client'
import { attachVoiceAudio } from './attachVoiceAudio'
import { decodeVoiceEvent, VOICE_TOPIC } from './voiceProtocol'
import { recordVoiceTiming } from './voiceLatency'

export function bindVoiceRoomEvents(room, refs) {
  const { detachAudioRef, onTranscriptRef, orchestratorRef, setState, roomRef } = refs
  room.on(RoomEvent.DataReceived, (payload, participant, _kind, topic) => {
    if (topic !== VOICE_TOPIC) return
    if (!participant || participant.kind !== ParticipantKind.AGENT) return
    const event = decodeVoiceEvent(payload)
    if (event?.type === 'transcript' && event.final && event.text) {
      recordVoiceTiming({ ...event, name: 'final_transcript' })
      onTranscriptRef.current?.(event.text)
    }
    if (event?.type === 'timing') recordVoiceTiming(event)
    if (event?.type === 'playback') setState((current) => ({ ...current, sentence: event.action === 'speaking' ? event.text || '' : '' }))
  })
  room.on(RoomEvent.TrackSubscribed, (track) => {
    const timing = () => orchestratorRef.current?.publish({ type: 'client_timing', name: 'browser_audio_start', timestamp_ms: Date.now() })
    if (track.kind === Track.Kind.Audio) detachAudioRef.current.push(attachVoiceAudio(track, timing))
  })
  room.on(RoomEvent.Disconnected, () => {
    orchestratorRef.current?.stop()
    orchestratorRef.current = null
    detachAudioRef.current.splice(0).forEach((detach) => detach())
    roomRef.current = null
    setState({ status: 'idle', error: '', sentence: '' })
  })
}
